<template>
  <v-alert :title="`${value} / ${compare}`"
  :type="alertType"
  class="text-white">
    {{ formattedValue }} {{ suffix }}
    <span style="font-size: smaller; float: right">({{ min}} - {{ max }})</span>
  </v-alert>
</template>

<script>
export default {
  name: 'ColouredValue',
  props: ['value', 'min', 'max', 'percentage', 'compare', 'suffix'],
  computed: {
    actual() {
      const { value, compare } = this;
      return (value / compare) * 100;
    },
    formattedValue() {
      const result = this.actual?.toFixed(2) ?? 0;
      if (result === 'NaN') {
        return 0;
      }
      return result;
    },
    isSuccess() {
      return this.actual >= this.min && this.actual <= this.max;
    },
    isError() {
      return this.actual < this.min || this.actual > this.max;
    },
    alertType() {
      if (this.isSuccess) {
        return 'success';
      }
      return 'error';
    },
  },
};
</script>
<style scoped>
.text-success {
  color: green;
}
.text-error {
  color: red;
}
</style>
